import ApiCrud from './ApiCrud';

export default class ApiCrudStore2 extends ApiCrud {
  update (item, opts) {
    return this._callProto('update', { data: item, ...opts });
  }

  create (item, opts) {
    return this._callProto('create', { data: item, ...opts });
  }

  delete (item, opts) {
    return this._callProto('delete', { data: item, ...opts });
  }
}
